export const tokenLength = 24;

export const requestPasswordResetTokenUrl = '/server-webservices/resetPassword';

export const RedeemTokenTypeToURLMap = {
  NEW_USER: '/server-webservices/redeemNewUserToken',
  PASSWORD_RESET: '/server-webservices/redeemPasswordResetToken',
  EMAIL_CONFIRMATION: '/server-webservices/redeemEmailConfirmationToken',
};
